import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { LocalDate } from '@js-joda/core';
import { Department } from '../../api/department';
import { TimeframeWithLocalTimes } from '../../api/shared';
import { Courtroom } from '../location';
import { RecordingSegment } from './RecordingSegment';
/**
 * Details of a recording, summarised for a list view
 */
export class RecordingSummary {
    /**
     * @param id Identifies the recording
     * @param courtSystemId The court system the recording belongs to
     * @param name The name of the recording
     * @param date The date the recording was recorded on
     * @param conversionStatus The progress of the recording's conversion into a playable version
     * This will be `undefined` when the conversion has not completed.
     * @param courtroom The courtroom the recording is linked to
     * @param segments Trm files or streams etc which make up the recording
     * @param hasVideo Whether this recording has video
     * @param department The department the recording is linked to
     * @param recordingType Type of recording, eg TRM, Stream
     * @param sttEnabled `true` for TRM recordings if speech to text is enabled; always `true` for stream recordings
     * @param bundleEnabled `true` for TRM recordings if bundle downloads are enabled; always `false` for stream recordings
     * @param departmentsEnabled `true` if departments are enabled
     * @param onTheRecordTimeframes Timeframes in which this recording is on the record (Stream only)
     * @param availableTimeframes The precise local times that the user can access in this recording (Stream only)
     * @param hasSealedContent Whether there are any sealed segments for this recording
     * @param hasLogSheets Whether there are any log sheets for this recording
     * @param hasStt Whether there is speech to text for this recording
     */
    constructor(id, courtSystemId, name, date, conversionStatus, courtroom, segments, hasVideo, department, recordingType, sttEnabled, bundleEnabled, departmentsEnabled, onTheRecordTimeframes, availableTimeframes, hasSealedContent, hasLogSheets, hasStt) {
        this.id = id;
        this.courtSystemId = courtSystemId;
        this.name = name;
        this.conversionStatus = conversionStatus;
        this.hasVideo = hasVideo;
        this.recordingType = recordingType;
        this.sttEnabled = sttEnabled;
        this.bundleEnabled = bundleEnabled;
        this.departmentsEnabled = departmentsEnabled;
        this.onTheRecordTimeframes = onTheRecordTimeframes;
        this.hasSealedContent = hasSealedContent;
        this.hasLogSheets = hasLogSheets;
        this.hasStt = hasStt;
        this.date = date;
        this.courtroom = courtroom;
        this.segments = segments;
        this.department = department;
        this.availableTimeframes = availableTimeframes;
    }
}
__decorate([
    Serialize(),
    __metadata("design:type", LocalDate)
], RecordingSummary.prototype, "date", void 0);
__decorate([
    Type(() => Courtroom),
    __metadata("design:type", Object)
], RecordingSummary.prototype, "courtroom", void 0);
__decorate([
    Type(() => RecordingSegment),
    __metadata("design:type", Array)
], RecordingSummary.prototype, "segments", void 0);
__decorate([
    Type(() => Department),
    __metadata("design:type", Object)
], RecordingSummary.prototype, "department", void 0);
__decorate([
    Type(() => TimeframeWithLocalTimes),
    __metadata("design:type", Array)
], RecordingSummary.prototype, "availableTimeframes", void 0);
